<template>
  <section class="block-offer offer" id="tradein">
    <section class="offer__container container_wide">
      <div class="offer__form-wrapper">
        <h2 class="offer__title">Честная оценка вашего автомобиля</h2>
        <h3 class="offer__subtitle">Дополнительная выгода при покупке в трейд-ин</h3>
        <callback-form
          class="offer__form callback-form"
          v-on="$listeners"
          :data="{ type: 'sale', form: 'competitor' }"
          :agreed="false"
        />
      </div>
    </section>
  </section>
</template>

<script>
import Mixin from "../common/mixin";
import Finance from "../common/finance";
import CallbackForm from "./callback-form";
import { complects } from "../common/cars-info";

export default {
  name: "block-offer",
  mixins: [Mixin, Finance],
  components: {
    CallbackForm,
  },
};
</script>

<style scoped lang="scss">
@import "../styles/constants.scss";

.offer {
  position: relative;
  width: 100%;
  height: 700px;
  background: url("../images/offer-2.jpg") no-repeat center/cover;

  &::before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    display: block;
    width: 100%;
    height: 100%;
    background: rgba(#000, 0.16);
  }

  &__container {
    position: relative;
    z-index: 2;
    display: flex;
    flex-direction: column;
    padding: 50px 20px 20px;
    max-width: 1800px;
  }

  &__form-wrapper {
    max-width: 415px;
    color: #fff;
  }

  &__title {
    margin-bottom: 20px;
    font-size: 28px;
    line-height: 1;
    text-transform: uppercase;
  }

  &__subtitle {
    margin-bottom: 30px;
    font-size: 22px;
    font-weight: 400;
    line-height: 1;
  }

  &__select {
    margin-bottom: 10px;
  }
}

@media (max-width: 1280px) {
  .offer {
    height: calc(100vw * 600 / 1280);
    max-height: 600px;
    min-height: 500px;
    background-position: top;

    &__title {
      font-size: calcFontSize(22, 28, 600, 1280);
    }

    &__subtitle {
      font-size: calcFontSize(20, 24, 600, 1200);
    }
  }
}

@media (max-width: 800px) {
  .offer {
    background-position: bottom;

    &__container,
    &__form-wrapper {
      height: 100%;
    }

    &__form-wrapper {
      display: flex;
      flex-direction: column;
    }

    &__form {
      margin-top: auto;
    }
  }
}

@media (max-width: 600px) {
  .offer {
    &__form-wrapper {
      max-width: 100%;
    }

    &__title {
      font-size: calcFontSize(24, 30, 320, 600);
    }

    &__subtitle {
      font-size: calcFontSize(18, 24, 320, 600);
    }
  }
}
</style>
